import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import StartPage from './StartPage'

ReactDOM.render(<StartPage />, document.getElementById('root'))
